import { rest } from "msw";
import { carnevalGuests } from "../responseResolvers/carnevalCruise";
import { localHost } from "./constants";

export const carnevalHandler = [
    rest.get(`${localHost}/api/carnival/bookingDetails`, carnevalGuests),
];
